export default class DonationForm {
  form: HTMLFormElement | null;
  radios: NodeListOf<HTMLInputElement>;
  checkboxFieldSet: HTMLFieldSetElement | null;
  checkbox: HTMLInputElement | null;
  customAmountInput: HTMLInputElement | null;

  constructor(
    formClass: string,
    radiosClass: string,
    checkboxClass: string,
    customAmountClass: string,
  ) {
    this.form = document.querySelector(`.${formClass}`);
    this.radios = document.querySelectorAll(
      `.${radiosClass} .gfield-choice-input`,
    );
    this.checkboxFieldSet = document.querySelector(`.${checkboxClass}`);
    this.checkbox =
      this.checkboxFieldSet?.querySelector(`.gfield-choice-input`) ?? null;
    this.customAmountInput = document.querySelector(
      `.${customAmountClass} .ginput_amount`,
    );

    this.handleCustomAmountChange = this.handleCustomAmountChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }

  roundUp(value: string): string {
    const num = parseFloat(value);
    return isNaN(num) ? "" : Math.ceil(num).toString();
  }

  handleCustomAmountChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const numericValue = parseFloat(
      target.value.replace(/[^\d.,]/g, "").replace(",", "."),
    );

    if (isNaN(numericValue)) {
      target.value = "";
    } else {
      target.value = `${Math.ceil(numericValue)},00 €`;
    }
  }

  handleCheckboxChange(): void {
    if (!this.checkboxFieldSet || !this.checkbox || !this.checkbox.checked)
      return;

    this.radios.forEach((radio) => (radio.checked = false));
    this.checkboxFieldSet.style.display = "none";
  }

  handleRadioChange(): void {
    if (!this.checkbox) return;

    this.checkbox.checked = false;
  }

  handleCustomFocus(): void {
    if (!this.checkbox) return;

    this.checkbox.checked = true;
    this.radios.forEach((radio) => (radio.checked = false));
  }

  init(): void {
    if (!this.form) return;

    this.customAmountInput?.addEventListener(
      "change",
      this.handleCustomAmountChange,
    );
    this.customAmountInput?.addEventListener("focus", () =>
      this.handleCustomFocus(),
    );

    this.checkbox?.addEventListener("change", this.handleCheckboxChange);

    this.radios.forEach((radio) => {
      radio.addEventListener("change", this.handleRadioChange);
    });
  }
}
